import {
  UPLOAD_FILE_REQUEST,
  UPLOAD_FILE_SUCCESS,
  SET_SELECTED_FILE,
  RESET_UPLOAD_FILE_STATE
} from "./UploadCsvTypes";

export const uploadFileRequest = (file, type) => ({
  type: UPLOAD_FILE_REQUEST,
  payload: { file, type }
});

export const uploadFileSuccess = (data, type) => ({
  type: UPLOAD_FILE_SUCCESS,
  payload: { data, type }
});

export const uploadFileFailure = (message, errorFields, fileType) => ({
  type: "UPLOAD_FILE_FAILURE",
  payload: {
    message,
    errorFields,
    fileType
  }
});

export const resetUploadCsvState = () => ({
  type: RESET_UPLOAD_FILE_STATE
});

export const setSelectedFile = (file) => ({
  type: SET_SELECTED_FILE,
  payload: file
});
